import { Patient } from '../types/patient'

/**
 * Export patients to CSV format
 */
export function exportPatientsToCSV(patients: Patient[]): void {
  if (patients.length === 0) {
    alert('No patients to export')
    return
  }

  // Define CSV headers
  const headers = [
    'Patient Number',
    'PPS Number',
    'GMS Number',
    'First Name',
    'Middle Name',
    'Last Name',
    'Date of Birth',
    'Gender',
    'Email',
    'Phone',
    'Address',
    'City',
    'State',
    'Postal Code',
    'Country',
    'Blood Type',
    'Allergies',
    'Insurance Provider',
    'Status',
  ]

  // Convert patients to CSV rows
  const rows = patients.map((patient) => [
    patient.patientNumber || patient.id.slice(0, 8),
    patient.ppsNumber || '',
    patient.gmsNumber || '',
    patient.firstName,
    patient.middleName || '',
    patient.lastName,
    new Date(patient.dateOfBirth).toLocaleDateString(),
    patient.gender,
    patient.email || '',
    patient.phone,
    patient.address?.street || '',
    patient.address?.city || '',
    patient.address?.state || '',
    patient.address?.postalCode || '',
    patient.address?.country || '',
    patient.bloodType || '',
    patient.allergies?.join('; ') || '',
    patient.insurance?.provider || '',
    patient.isArchived ? 'Archived' : patient.isActive ? 'Active' : 'Inactive',
  ])

  // Combine headers and rows
  const csvContent = [headers, ...rows]
    .map((row) => row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(','))
    .join('\n')

  // Create download link
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)

  link.setAttribute('href', url)
  link.setAttribute('download', `patients_export_${new Date().toISOString().split('T')[0]}.csv`)
  link.style.visibility = 'hidden'

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

/**
 * Export patients to JSON format
 */
export function exportPatientsToJSON(patients: Patient[]): void {
  if (patients.length === 0) {
    alert('No patients to export')
    return
  }

  const jsonContent = JSON.stringify(patients, null, 2)
  const blob = new Blob([jsonContent], { type: 'application/json' })
  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)

  link.setAttribute('href', url)
  link.setAttribute('download', `patients_export_${new Date().toISOString().split('T')[0]}.json`)
  link.style.visibility = 'hidden'

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

